import { useMediaQuery } from './useMediaQuery';
import { useTheme } from './useTheme';

/**
 * Note: Try not to use this hook in conditional rendering to avoid
 * issues such as CLS since most of the pages are SSR
 * Hooks like this one are loaded after the "hydration" - client side event
 * If the page isn't SSR, feel free to use this hook for your own case
 */
export const useIsDesktop = () => {
  const {
    theme
  } = useTheme();
  if (!theme || theme.breakpoints.length === 0) {
    return false;
  }

  /* Disabled the linter error
  React Hook "useMediaQuery" is called conditionally.
  React Hooks must be called in the exact same order in every component render.
  Did you accidentally call a React Hook after an early return? */

  const {
    matched
    // eslint-disable-next-line react-hooks/rules-of-hooks
  } = useMediaQuery({
    minWidth: theme.breakpoints[1]
  });
  return matched;
};